import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";
import { Button } from "@/components/ui/button";

function pageList(page, pages) {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const set = new Set([1, pages, page - 1, page, page + 1].filter((p) => p >= 1 && p <= pages));
  const out = [];
  [...set].sort((a, b) => a - b).forEach((p, i, arr) => { if (i && p - arr[i - 1] > 1) out.push("…"); out.push(p); });
  return out;
}

export default function Pagination({ page, pages, total, limit, onChange, label = "candidates", busy }) {
  if (!total) return null;
  const from = (page - 1) * limit + 1, to = Math.min(page * limit, total);
  const go = (p) => { if (p >= 1 && p <= pages && p !== page) onChange(p); };
  const btn = "h-8 min-w-8 px-2 rounded-lg text-xs";
  return (
    <div className="print-hide flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 py-3 border-t border-slate-100 bg-white" data-testid="pagination">
      <p className="text-xs text-slate-600" data-testid="pagination-summary">Showing {from}–{to} of {total} {label}</p>
      <nav className="flex flex-wrap items-center gap-1" aria-label="Pagination">
        <Button size="sm" variant="outline" className={btn} data-testid="page-first" disabled={page <= 1 || busy} onClick={() => go(1)} aria-label="First page"><ChevronsLeft className="w-3.5 h-3.5" /></Button>
        <Button size="sm" variant="outline" className={btn} data-testid="page-prev" disabled={page <= 1 || busy} onClick={() => go(page - 1)} aria-label="Previous page"><ChevronLeft className="w-3.5 h-3.5" /></Button>
        {pageList(page, pages).map((p, i) => p === "…" ? <span key={`e${i}`} className="px-1 text-xs text-slate-400">…</span> :
          <Button key={p} size="sm" variant={p === page ? "default" : "outline"} data-testid={`page-${p}`} aria-current={p === page ? "page" : undefined} disabled={busy} onClick={() => go(p)} className={`${btn} ${p === page ? "bg-emerald-700 hover:bg-emerald-800 text-white" : ""}`}>{p}</Button>)}
        <Button size="sm" variant="outline" className={btn} data-testid="page-next" disabled={page >= pages || busy} onClick={() => go(page + 1)} aria-label="Next page"><ChevronRight className="w-3.5 h-3.5" /></Button>
        <Button size="sm" variant="outline" className={btn} data-testid="page-last" disabled={page >= pages || busy} onClick={() => go(pages)} aria-label="Last page"><ChevronsRight className="w-3.5 h-3.5" /></Button>
      </nav>
    </div>
  );
}
